<template>
  <div class="layoutwrapper">
      <div class="title">
          <div class="tip">
              <img src="@/assets/login/logo.png" >
              <div class="name">杭州第四中学吴山公寓家校绑定系统</div>
          </div>
          <div class="buttonBox">
            <div class="logout" @click="update()">同步数据</div>
            <div class="logout" @click="logout()">退出</div>
          </div>
      </div>
      <div class="box" >
          <sidebar></sidebar>
          <div class="mainPageBox"
    v-loading="loading"
    element-loading-text="拼命加载中">
            <router-view class="mainPage"/>
          </div>
      </div>
  </div>
</template>

<script>
import sidebar from './sidebar.vue'
export default {
    components:{
        sidebar
    },
    data(){
        return{
            loading:false
        }
    },
    methods:{
        logout(){
            this.$http.post('/attendance/auth/logout').then(res=>{
                localStorage.removeItem('header')
                this.$router.push('/login')
            })
        },
        update(){
            this.loading = true
            this.$http.post('/attendance/student/syncDept').then(res=>{
                this.$http.post('/attendance/student/syncUser').then(res=>{
                    this.loading = false
                })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.layoutwrapper{
    // border: 2px red solid;
    width: 100%;
    height: 100%;
    .title{
        width: 100%;
        background-color: #D9E1EC;
        height: 3.33rem;
        display: flex;
        justify-content: space-between;
        align-items: center ;
        .tip{
            font-size: 1.25rem;
            font-weight: 400;
            color: #3E3A39;
            margin-left: 2.33rem;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            img{
                margin-right: 0.83rem;
                width: 5rem;
                height: 5rem;
            }
        }
        .buttonBox{
            display: flex;
            justify-content: flex-start;
            align-content: center;
        }
        .logout{
            cursor: pointer;
            font-size: .8rem;
            font-family: Source Han Sans SC;
            line-height: 1.5rem;
            color: #3E3A39;
            margin-right: 1.75rem;
            border: 1px rgba(0, 0, 0, 0) solid;
            background-color: #3399FF;
            height: 1.5rem;  
            padding: 0 .4rem;
            border-radius: 3px;
            text-align: center;
        }
        .logout:active{
            border: 1px #000 solid;
        }
    }
    .box{
        background-color: #F0F2F5 ;
        width: 100%;
        height: calc(100% - 3.33rem);
        display: flex;
        align-items: center;
        .mainPageBox{
            width: 89.5%;
            height: 100%;
            .mainPage{
                width: 100%;
                height: 100%;
                padding: 1rem;
                padding-bottom: 0;
                box-sizing: border-box;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/layout/layout.vue